export function ensureArray<T>(val: null | T[] | undefined): T[] {
  if (Array.isArray(val)) {
    return val
  } else {
    return []
  }
}
